import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { useDesktop, useQuery } from '../../hooks/common'
import { useSelector, useDispatch } from 'react-redux'
import {
    action_fetch_product_vo,
    action_fetch_product_coupon_message,
} from '../../../store/actions/pages/product'
import { action_fetch_cart_count, setWishList } from '../../../store/actions/global'
import { addToCart, saveWishListProduct as apiAddToWishList, removeWishListProduct as apiRemoveFromWishList, fetchUpdateGift, updateAddOnItem } from '../../../api'
import { getAddOnDelPrice, getDelPrice, getLowerPrice } from '../../../utils/product'
import GeekoEvents from '../../ads/events'
import { useRef } from 'react'
import { IMAGE_GEEKO_LTD } from '../../../constants'
import { action_fetch_cart, setCartTrigger } from '../../../store/actions/global'
import { useSensors } from '../../hooks/sensor'
import toast from '../../components/toast'
import { fbContentView, fbAddToCart } from '../../../api/facebook-ctm-ads'
import { getOriginalSize } from '../../utils/sensor'
import Cache from '../../../utils/cache'

export const useProduct = () => {

    const query = useQuery()
    const params = useParams()

    const dispatch = useDispatch()
    const inited = useRef(true)

    const pageProduct = useSelector((state) => state.pageProduct)
    const pageGlobal = useSelector(state => state.global)
    const [reviewSummary, setReviewSummary] = useState(pageProduct.reviewSummary)
    // const [discountMessage, setDiscountMessage] = useState(pageProduct.discountMessage)
    const [productVO, setProductVO] = useState(pageProduct.productVO)
    const [carting, setCarting] = useState(false)
    const [wishing, setWishing] = useState(false)
    const [quantity, setQuantity] = useState(1)
    const [cartImage, setCartImage] = useState(null)
    const [selectedName, setSelectedName] = useState("youlikes");

    const sp = productVO?.products?.find(p => p.id === productVO?.selectedProductId && p.color === query.color) || productVO?.products?.find(p => p.id === productVO?.selectedProductId) || productVO?.products?.[0]

    const [selectedProduct, setSelectedProduct] = useState(sp)
    const [selectedVariant, setSelectedVariant] = useState((sp?.variants?.length === 1) || pageProduct.productVO?.style === 1 ? sp?.variants?.[0] : null)
    const isBeautyMakeup = productVO?.style === 1;

    const [sensors, setSensors] = useState(useSensors())

    const [taglia, setTaglia] = useState(pageProduct?.taglia)

    const isATest = useMemo(() => {
        return false;
    }, []);

    const estimatedPercent = useMemo(() => {
        if (selectedProduct) {
            let highPrice = getAddOnDelPrice(selectedProduct)
            let estimatedPrice = selectedProduct?.estimatedPrice
            if (estimatedPrice) {
                return Math.round((Math.abs(estimatedPrice?.amount - highPrice?.amount) / highPrice?.amount) * 100)
            } else {
                return null
            }
        }
    }, [selectedProduct])

    const pageView = useCallback(data => {




        try {
            GeekoEvents.pageView({
                productId: data?.productId,
                product_type: data?.product_type,
                amount: data?.amount,
                currency: data?.currency,
                name: data?.name,
                sensors
            })

            //facebook messenager
            fbContentView(data?.productId, data?.amount, data?.currency)


        } catch (e) {
            console.error(e)
        }

    }, [])

    const selectProduct = (productId, color, variant) => {
        const sp = productVO?.products?.find(p => p.id === productId && p?.variants[0]?.color === color) || productVO?.products?.find(p => p.id === productId)
        setSelectedProduct(sp)
        if (sp?.saved) {
            dispatch(setWishList([...(pageGlobal.wishlist || []), productId]))
        }


        if ((sp?.variants?.length === 1) || productVO?.style === 1) {
            setSelectedVariant(sp?.variants?.[0])
        } else {
            variant ?
                selectVariant(null, variant) : selectVariant(null);
        }

        const lower = getLowerPrice(sp)

        pageView({ productId: sp?.id, product_type: query?.product_type, amount: lower?.amount, currency: lower?.currency, name: sp?.name })
    }

    const selectVariant = (variantId, variant) => {
        variant ?
            setSelectedVariant(variant) :
            setSelectedVariant(selectedProduct?.variants?.find(v => v.id === variantId))
    }

    const productAddToCart = async () => {
        let isGift = query?.product_type === "gift";
        let isAddOn = query?.product_type === 'addOn';
        setCarting(true)
        let response
        if (isGift) {
            response = await fetchUpdateGift(selectedVariant?.id)
        } else if (isAddOn) {
            response = await updateAddOnItem({
                variantId: selectedVariant?.id,
                oldProductId: selectedProduct?.id
            })
        } else {
            response = await addToCart({
                quantity,
                variantId: selectedVariant?.id,
                unifiedId: selectedVariant.domesticDelivery?.enabled ? selectedVariant.unifiedId : undefined,
                warehouseId: selectedVariant.domesticDelivery?.enabled ? selectedVariant.domesticDelivery?.warehouseId : undefined,
                shippedCountryCode: selectedVariant.domesticDelivery?.enabled ? selectedVariant.domesticDelivery?.countryCode : undefined
            })
        }
        try {
            const lower = getLowerPrice(selectedProduct)

            const has_added_purchase = Cache.get('has_added_purchase')

            let shouldAddPurchase = false

            if (!has_added_purchase) {
                Cache.set('has_added_purchase', 1)
            }

            const random = pageGlobal.random
            const country = pageGlobal.country
            const countryRandom = random?.[country] || random?.['defaultRandom']
            let shouldUsePurchaseLogic = false

            if(countryRandom?.type === '1'){
                shouldUsePurchaseLogic = selectedProduct?.isSelfie
            }else if(countryRandom?.type === '2'){
                shouldUsePurchaseLogic = pageGlobal?.user?.id
            }

            if (window.utm_source === 'facebook' && countryRandom && shouldUsePurchaseLogic) {
                const { ios, android } = countryRandom
                if (!!pageGlobal.isiPhone && ios) {
                    shouldAddPurchase = !!!has_added_purchase && Math.random() <= Number(ios)
                }

                if (!!pageGlobal.isAndroid && android) {
                    shouldAddPurchase = !!!has_added_purchase && Math.random() <= Number(android)
                }
            }

            GeekoEvents.addToCart({
                productId: selectedProduct?.id,
                sku: selectedProduct.parentSku,
                variantId: selectedVariant?.id,
                variantSku: selectedVariant?.sku,
                variantSize: getOriginalSize(selectedVariant?.size),
                usdPrice: selectedVariant?.salesPriceWithUSD?.amount,
                quantity: quantity,
                amount: lower?.amount,
                currency: lower?.currency,
                name: selectedProduct.name,
                is_success: response?.code === 200,
                isGift: !!isGift,
                sensors,
                shouldAddPurchase
            })






            fbAddToCart(selectedProduct?.id, lower?.amount, lower?.currency)

        } catch (e) {
            console.error(e)
        }
        setCarting(false)

        if (response?.code === 200) {
            // pc处理购物车方式
            if (pageGlobal?.isDesktop) {
                await dispatch(action_fetch_cart());
                dispatch(setCartTrigger());
            } else {
                // document.getElementById("youLikesNav")?.scrollIntoView?.({
                //     behavior: 'smooth'
                // })

                if (document.getElementById("youLikesNav")) {
                    let domCurrent = document.getElementById("youLikesNav");
                    let currentOffsetTop = domCurrent.offsetTop + domCurrent.offsetParent.offsetTop;
                    // console.log('currentOffsetTop', currentOffsetTop)

                    window.scrollTo({
                        top: currentOffsetTop - 98,
                        behavior: 'smooth'
                    })
                }

                setCartImage(`${IMAGE_GEEKO_LTD}/small/${selectedProduct?.variants?.[0]?.image || selectedProduct?.pcMainImage}`)
                setTimeout(() => {
                    setCartImage(null)
                }, 400)


                dispatch(action_fetch_product_coupon_message())

                // dispatch(action_fetch_often_with_products(selectedProduct?.id));
            }

            dispatch(action_fetch_cart_count())
        } else {
            toast(response?.result, { isDesktop: pageGlobal?.isDesktop })
        }
        return response
    }

    const addToWishList = async () => {
        let newWish
        const hasExistInWishList = pageGlobal.wishlist?.some(pid => pid === selectedProduct?.id)
        if (hasExistInWishList) {
            newWish = pageGlobal.wishlist?.filter(pId => pId !== selectedProduct?.id)
            await apiRemoveFromWishList(selectedProduct?.id)
            dispatch(setWishList(newWish))
        } else {
            newWish = [...(pageGlobal.wishlist || []), selectedProduct?.id]
            const response = await apiAddToWishList(selectedProduct?.id)
            if (response?.code != 200) {
                alert(response?.result)
            } else {
                dispatch(setWishList(newWish))
            }
            GeekoEvents.addToWishList({
                productId: selectedProduct?.id,
                product_type: query?.product_type,
                sensors
            })
        }
    }


    useEffect(() => {

        const lower = getLowerPrice(selectedProduct)

        pageView({ productId: selectedProduct?.id, product_type: query?.product_type, sku: selectedProduct?.parentSku, currency: selectedProduct?.price?.currency, amount: lower?.amount, name: selectedProduct?.name })
    }, [])




    useEffect(async () => {
        const vo = pageProduct.productVO;
        setProductVO(vo)
        //修改了一个bug   当完全匹配不到产品的时候   用products[0]
        const selected = vo?.products?.find(p => p.id === vo?.selectedProductId && p.color === query.color) || vo?.products?.find(p => p.id === vo?.selectedProductId) || vo?.products?.[0];
        setSelectedProduct(selected)
        if (selected?.saved) {
            dispatch(setWishList([...(pageGlobal.wishlist || []), vo?.selectedProductId]))
        }

        // selected?.variants?.length === 1 && !!!selected?.variants?.[0]?.size) || vo?.style === 1
        if ((selected?.variants?.length === 1) || vo?.style === 1) {
            setSelectedVariant(selected?.variants?.[0])
        } else {
            setSelectedVariant(undefined)
        }
    }, [pageProduct.productVO])


    return {
        // discountMessage,
        reviewSummary,
        productVO,
        selectedProduct,
        selectedVariant,
        selectProduct,
        selectVariant,
        productAddToCart,
        carting,
        setCarting,
        addToWishList,
        wishing,
        quantity,
        setQuantity,
        cartImage,
        selectedName,
        setSelectedName,
        isBeautyMakeup,
        taglia,
        isATest,
        estimatedPercent,
        clogs: pageProduct.clogs
    }
}